let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5c8km")).then(() => parcelRequire('dynvU'));